const buildProp = (prop, key) => {
  if (prop.values && Array.isArray(prop.values)) {
    prop.validator = (value) => {
      if (!prop.values.includes(value)) {
        console.warn(
          `Invalid prop: validation failed${
            key ? ` for prop "${key}"` : ''
          }. Expected one of [${prop.values.join(', ')}], got value ${JSON.stringify(
            value,
          )}.`,
        );
        return false;
      }

      return true;
    };
  }

  return prop;
};

export const buildProps = (props) => {
  return _fromPairs(
    Object.entries(props).map(([key, option]) => [
      key,
      buildProp(option, key),
    ]),
  );
};
